module.exports = {
  schema: {
    name: '商品對應外部系統',
    type: 'Object',
    contents: {
      key: {
        type: 'String',
        name: '資料編碼',
        disabled: true,
        /* 前端自動組合 */
        counter: {
          key: () => 'E',
          value: (key, value) => `${key}${value}`,
        },
      },
      system: {
        type: 'String',
        name: '對應系統',
        required: true,
        options: ['F-寶聯', 'L-小林'],
      },
      brandRef: {
        type: 'ObjectId',
        name: '內部品牌',
        reference: 'brands',
        refKeys: ['key'],
      },
      priceRangeRef: {
        type: 'ObjectId',
        name: '內部價格區間',
        reference: 'priceRanges',
        refKeys: ['key'],
      },
      productRef: {
        type: 'ObjectId',
        name: '內部商品',
        required: true,
        reference: 'products',
        refKeys: ['key'],
      },
      extProductKey: {
        type: 'String',
        name: '外部商品編號',
      },
      extProductName: {
        type: 'String',
        name: '外部商品名稱',
      },
      isConsignment: {
        type: 'Boolean',
        name: '寄賣',
      },
    },
  },
  index: {
    primary: {
      key: {
        key: 1,
      },
      unique: true,
    },
  },
  ui: {
    list: {
      columns: [
        { key: 'key', width: 80 },
        { key: 'system' },
        { key: 'brandRef', width: 80 },
        { key: 'priceRangeRef', width: 110 },
        { key: 'productRef' },
        { key: 'extProductKey', width: 200 },
        { key: 'extProductName', width: 110 },
        { key: 'isConsignment' },
      ],
    },
    editor: {
      config: { nameWidth: 150 },
      groups: [
        {
          name: '',
          rows: [
            [{ key: 'key' }, { key: 'system' }],
            [{ key: 'brandRef' }, { key: 'isConsignment' }],
            [{ key: 'priceRangeRef' }, { key: 'productRef' }],
            [{ key: 'extProductKey' }, { key: 'extProductName' }],
          ],
        },
      ],
    },
  },
}



// WEBPACK FOOTER //
// ./src/models/externalProducts.js